import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "carfix_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const submitFranchise = (data) =>
  axios.post(`${API}/leads/franchise`, data).then((r) => r.data);

export const submitBooking = (data) =>
  axios.post(`${API}/leads/booking`, data).then((r) => r.data);

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);

export const fetchMe = () =>
  axios.get(`${API}/auth/me`, { headers: authHeaders() }).then((r) => r.data);

export const fetchLeads = (kind) =>
  axios
    .get(`${API}/admin/leads`, {
      headers: authHeaders(),
      params: kind ? { kind } : {},
    })
    .then((r) => r.data);

export const fetchStats = () =>
  axios.get(`${API}/admin/stats`, { headers: authHeaders() }).then((r) => r.data);

export const markLeadRead = (id) =>
  axios
    .patch(`${API}/admin/leads/${id}/read`, {}, { headers: authHeaders() })
    .then((r) => r.data);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  return String(detail);
};
